import { FC, ReactNode } from 'react';
import Toolbar from '@mui/material/Toolbar';
import { APPBAR_INT_HEIGHT } from '../constants/layout';

export interface AppBarInternalToolbarProps {
  children?: ReactNode[];
}

const AppBarInternalToolbar: FC<AppBarInternalToolbarProps> = (props) => {
  return <Toolbar sx={{ minHeight: { xs: APPBAR_INT_HEIGHT } }} {...props} />;
};

export default AppBarInternalToolbar;
